const _orderObjectProperties = (obj: any) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj;

  return Object.keys(obj)
    .sort()
    .reduce((acc: any, key) => {
      acc[key] = _orderObjectProperties(obj[key]);

      return acc;
    }, {});
};

export const areSameObjects = (first: any, second: any) => {
  if (!first || !second) return first === second;

  const orderedFirst = _orderObjectProperties(first);
  const orderedSecond = _orderObjectProperties(second);

  return JSON.stringify(orderedFirst) === JSON.stringify(orderedSecond);
};
